/**
 * Badge · StatusDot — durum göstergeleri.
 *
 * ═══════════════════════════════════════════════════════════════════════════
 * RENK TEK BAŞINA ANLAM TAŞIMAZ.
 *
 * Her durum HEM renk HEM metin taşır. Renk körlüğü (erkeklerde ~%8), güneş
 * altında okunan telefon ekranı, ve siyah-beyaz çıktı — üçü de rengi
 * güvenilmez kılar. Bu, veri katmanındaki `bad ≠ 0` ayrımının arayüzdeki
 * karşılığıdır: gösterge belirsiz bırakmamalı.
 * ═══════════════════════════════════════════════════════════════════════════
 */
import { cx } from './cx.ts';

export type Tone = 'ok' | 'warn' | 'danger' | 'offline' | 'neutral';

const TONE: Record<Tone, { chip: string; dot: string }> = {
  ok: { chip: 'bg-ok-bg text-ok', dot: 'bg-ok' },
  warn: { chip: 'bg-warn-bg text-warn', dot: 'bg-warn' },
  danger: { chip: 'bg-danger-bg text-danger', dot: 'bg-danger' },
  // Çevrimdışı GRİ — alarm değil, bilgi eksikliği (bkz. styles.css).
  offline: { chip: 'bg-offline-bg text-offline', dot: 'bg-offline' },
  neutral: { chip: 'bg-surface-sunken text-ink-muted', dot: 'bg-ink-muted' },
};

export interface BadgeProps {
  readonly tone?: Tone;
  readonly children: React.ReactNode;
}

export function Badge({ tone = 'neutral', children }: BadgeProps): React.JSX.Element {
  return (
    <span
      className={cx(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium',
        TONE[tone].chip,
      )}
    >
      <span className={cx('size-1.5 rounded-full', TONE[tone].dot)} aria-hidden="true" />
      {children}
    </span>
  );
}

export interface StatusDotProps {
  readonly tone: Tone;
  /** Ekran okuyucuya okunacak metin — GÖRSEL nokta tek başına yetmez. */
  readonly label: string;
}

export function StatusDot({ tone, label }: StatusDotProps): React.JSX.Element {
  return (
    <span className="inline-flex items-center gap-2">
      <span className={cx('size-2.5 rounded-full', TONE[tone].dot)} aria-hidden="true" />
      <span className="sr-only">{label}</span>
    </span>
  );
}
